// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KDlV","type":"styles_type__irJ9D","choices":"styles_choices__3CwT5"};